module.exports = __webpack_public_path__ + "static/media/491JamesPBrawleyNW_2018-06-12_89.a7f29d00.jpg";